<template>
<div>
	<edit-container 
		ref="editContainer"
		type="person" 
		:handle="['edit','add','replace','refund']"
		:file-url="fileUrl"
		@add="add"
		@edit="edit"
		@replace="replace"
		@refund="refund"
		@set-data="setData"
		@set-info="setInfo">
		<SchemeTable slot="thead" :type="isOld?'oldPerson':'person'" :quoteVersion="quoteVersion" />
		<div slot="file" class="mt20">
			<div v-if="type=='PERSON'">
				<Alert type="warning">
					请将新增和新替换的参加人员上传雇佣合同，无相关材料人员出险后保险公司有权拒赔。
				</Alert>
				<UploadFileImg @on-success="uploadSuccess" style="width:200px">
					<div class="mt10">
						<Icon type="ios-cloud-upload-outline" size="20" />
						<p>{{fileUrl?'重新':''}}上传雇佣合同</p>
					</div>
					<a :href="fileUrl" target="_blank" v-if="fileUrl" @click.stop>查看</a>
				</UploadFileImg>
			</div>
		</div>
	</edit-container>
	
	<Modal
		v-model="addShow"
		title="添加人员信息"
        width="400px"
        :mask-closable="false">
		<Form :model="addForm" ref="addForm" :label-width="100" :rules="addFormRules">
			<FormItem label="姓名" prop="insuredPersonName">
		        <Input type="text" v-model="addForm.insuredPersonName" ></Input>
		    </FormItem>
		    <FormItem label="证件号" prop="idCard">
		        <Input type="text" v-model="addForm.idCard" ></Input>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="addShow=false">取消</Button>
			<Button type="primary" @click="confirmAdd" >确定</Button>
		</template>
	</Modal>
	<Modal
		v-model="editShow"
		title="编辑人员信息"
        width="400px"
        :mask-closable="false">
		<Form :model="editForm" ref="editForm" :label-width="100" :rules="editFormRules" @submit.native.prevent>
			<FormItem label="姓名" prop="insuredPersonName">
		        <Input type="text" v-model="editForm.insuredPersonName" ></Input>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="editShow=false">取消</Button>
			<Button type="primary" @click="confirmEdit">确定</Button>
		</template>
	</Modal>
	
	<Modal
		v-model="replaceShow"
		title="人员替换"
        :mask-closable="false">
		<Card title="原员工">
			<Form :label-width="90">
				<FormItem label="姓名：" class="mb0">
					{{replaceData.insuredPersonName}}
				</FormItem>
				<FormItem label="证件号：" class="mb0">
					{{replaceData.idCard}}
				</FormItem>
			
				<FormItem label="保障方案：" class="mb0">
					{{replaceData.scheme}}
				</FormItem>
			</Form>
		</Card>
		<Card title="替换后员工">
			<Alert type="warning">保障方案同被替换员工一致</Alert>
			<Form :model="replaceForm" ref="replaceForm" :label-width="100" :rules="replaceFormRules">
				<FormItem label="姓名" prop="insuredPersonName">
					<Input type="text" v-model="replaceForm.insuredPersonName" ></Input>
				</FormItem>
				<FormItem label="证件号" prop="idCard">
					<Input type="text" v-model="replaceForm.idCard" ></Input>
				</FormItem>
			</Form>
		</Card>
		
		<template slot="footer">
			<Button type="text" @click="replaceShow=false">取消</Button>
			<Button type="primary" @click="confirmReplace" >确定</Button>
		</template>
	</Modal>
</div>
</template>
<script>
import SchemeTable from '../common/SchemeTable'
import EditContainer from '@/pages/haierProduct/components/common/EditContainer'
import UploadFileImg from '@/components/common/UploadFileImg'
export default {
	components:{ SchemeTable,EditContainer,UploadFileImg },
	data () {
		return {
			list:[],
			addShow:false,
			addForm:{},
			addFormRules:{
				insuredPersonName:{required:true,message:'请填写姓名',trigger:'blur'},
				idCard:[{required:true,message:'请填写证件号',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.idcard}],
			},
			editShow:false,
			editForm:{},
			editFormRules:{
				insuredPersonName:{required:true,message:'请填写姓名',trigger:'blur'},
			},
			replaceShow:false,
			replaceData:{},
			replaceForm:{},
			replaceFormRules:{
				insuredPersonName:{required:true,message:'请填写姓名',trigger:'blur'},
				idCard:[{required:true,message:'请填写证件号',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.idcard}],
			},
			fileUrl:'',
			type:'',
			isOld:true,
			quoteVersion:1
		}
	},
	created () {
	},
	methods:{
		setInfo(info){
			this.type=info.applicantInfo?info.applicantInfo.identityType:''
			this.fileUrl=this.type=='COMPANY'?'NO':''
			this.isOld=info.createTime&&Date.parse(info.createTime)<Date.parse('2021/08/02 00:00:00')
			this.quoteVersion = info.quoteVersion
		},
		setData(list) {
			this.list=list;
		},
        uploadSuccess(val){
            this.fileUrl=val.url
        },
		// 添加
		add() {
			this.addShow=true;
			this.$refs.addForm.resetFields();
			this.addForm={
				operation:'ADD'
			};
		},
		// 确定
		confirmAdd(){
			this.$refs.addForm.validate(async valid=>{
				if(valid){
					let index=this.list.findIndex(item=>{
						return item.idCard==this.addForm.idCard&&item.operation!='REMOVE'
					})
					if(index!=-1){
						this.alert('此身份证号对应人员已承保')
						return
					}
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push(this.addForm)
					await this.$refs.editContainer.getHandleList(list)
					this.addShow=false
				}
			})
		},
		// 打开修改名字
		edit(row){
			this.editShow=true;
			this.$refs.editForm.resetFields();
			this.editForm=this.jsonCopy(row);
		},
		// 确定修改
		confirmEdit(){
			this.$refs.editForm.validate(async valid=>{
				if(valid){
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push({
						...this.editForm,
						operation:'EDIT'
					})
					await this.$refs.editContainer.getHandleList(list)
					this.editShow=false;
				}
			})
		},
		// 打开替换
		replace(row) {
			this.replaceShow=true;
			this.$refs.replaceForm.resetFields();
			this.replaceData=row;
			this.replaceForm={
				no:row.no
			};
		},
		// 退保
		refund(row) {
			this.confirm('确定该名员工退出保障计划吗？<br />确认后，将把员工状态临时置为已失效，“提交信息”后才最终生效', () => {
				let list = this.list.filter(item => item.operation !== 'INIT');
				list.push({
					...row,
					operation: 'REMOVE'
				});
				this.$refs.editContainer.getHandleList(list);
			});
		},
		// 确定替换
		confirmReplace() {
			this.$refs.replaceForm.validate(async valid=>{
				if(valid){
					let index=this.list.findIndex(item=>{
						return item.idCard==this.replaceForm.idCard&&item.operation!='REMOVE'
					})
					if(index!=-1){
						this.alert('此身份证号对应人员已承保')
						return
					}
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push({
						...this.replaceForm,
						operation:'REPLACE'
					})
					await this.$refs.editContainer.getHandleList(list)
					this.replaceShow=false;
				}
			})
		},
	}
}
</script>
<style scoped lang="less">
.mb0{
	margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/person/Edit.vue